export default __webpack_public_path__ + "static/media/bubbleabc.a76b7cda.png";